import { call, put, takeEvery, takeLatest } from "@redux-saga/core/effects";
import {
  START_GET_LOGIN_USER,
  SUCCESS_GET_LOGIN_USER,
  ERROR_GET_LOGIN_USER,
  START_GET_PHARMACY_CONFIG,
  SUCCESS_GET_PHARMACY_CONFIG,
  ERROR_GET_PHARMACY_CONFIG,
  SUCCESS_GET_REFRESHTOKEN,
  ERROR_GET_REFRESHTOKEN,
  START_GET_REFRESHTOKEN,
  START_UPDATE_FIRST_LOGIN_TOUR,
  SUCCESS_UPDATE_FIRST_LOGIN_TOUR,
  ERROR_UPDATE_FIRST_LOGIN_TOUR,
} from "Actions/UserAction";
import {
  getLoginUserAPI,
  getPharmacyConfigAPI,
  getRefreshTokenAPI,
  updateFirstLoginTourAPI,
} from "Api/UserApi";

function* getLoginUserWorker() {
  try {
    const res = yield call(getLoginUserAPI);
    if (res?.success) {
      // localStorage.setItem("LastTokenRefreshedAt", Date.now()); 
      yield put({
        type: SUCCESS_GET_LOGIN_USER,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_LOGIN_USER,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getRefreshTokenWorker({ payload }) {
  try {
    const res = yield call(getRefreshTokenAPI, payload);
    if (res?.success) {
      if (res?.data?.token) {
        // Set new token When Response arrives 
        localStorage.setItem("token", res?.data?.token);
        localStorage.setItem("LastTokenRefreshedAt", Date.now()); // TimeStamp
      }
      yield put({
        type: SUCCESS_GET_REFRESHTOKEN,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_REFRESHTOKEN,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getPharmacyConfigWorker({ payload }) {
  try {
    const res = yield call(getPharmacyConfigAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_GET_PHARMACY_CONFIG,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_PHARMACY_CONFIG,
        payload: res,
      });
    }
  } catch (error) {}
}

function* updateFirstLoginTourWorker({ payload }) {
  try {
    const res = yield call(updateFirstLoginTourAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_FIRST_LOGIN_TOUR,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_UPDATE_FIRST_LOGIN_TOUR,
        payload: res,
      });
    }
  } catch (error) {}
}

export function* UserWatcher() {
  yield takeEvery(START_GET_LOGIN_USER, getLoginUserWorker);
  yield takeEvery(START_GET_PHARMACY_CONFIG, getPharmacyConfigWorker);
  yield takeLatest(START_GET_REFRESHTOKEN, getRefreshTokenWorker);
  yield takeEvery(START_UPDATE_FIRST_LOGIN_TOUR, updateFirstLoginTourWorker);
}
